// extracted by mini-css-extract-plugin
export default {"mainLayout":"styles_mainLayout__y0d2q"};